import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './club-management.action';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ClubManagementTableService {

    constructor(
        private store: Store<RootReducerState>,
        private route: ActivatedRoute,
    ) { }
 
    clubId: number = 0; //Do not alter being used in club task tabs
    dossierId: number = 0; //Do not alter being used in dossier task tabs
    dossierClub: number = 0; //Do not alter being used in dossier task tabs

    pagination = [];
    filters = {
                created_at: '',
                club_name: null,
                communication_categories_name: null,
                created_by_name: '',
                task_statuses_name: null,
                last_message_at: '',
                member_name: ''
            };

    unReadTasks: string[];
    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    section = '';
    clubs = [];
    categories = [];
    statuses = [];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'club_name', name: 'COMMUNICATION.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name", widthSet:250},
                { prop: 'member_name', name: 'COMMUNICATION.member-name', sortable: true, hasFilter: true, filter: "input", widthSet: 180},
                { prop: 'communication_categories_name', name: 'COMMUNICATION.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name", widthSet: 180},
                { prop: 'created_by_name', name: 'COMMUNICATION.created_by', sortable: true, hasFilter: true, filter: "input", widthSet: 180},
                { prop: 'task_statuses_name', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name" , widthSet: 140},
                { prop: 'last_message_at', name: 'COMMUNICATION.last-message-at', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", minWidth: 100},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({id: this.clubId}));
    }

    hasActiveFilters(){
        if(
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'task_statuses_name' && (this.clubId !== 0 || this.dossierId !== 0)){
                    return value != '1';
                }

                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }
    
    resetState(){
        this.filters = {
            created_at: '',
            club_name: null,
            communication_categories_name: null,
            created_by_name: '',
            task_statuses_name: null,
            last_message_at: '',
            member_name: ''
        }

        this.filters.task_statuses_name = ((this.clubId === 0 && this.dossierId === 0) ? null : 1);

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }


   

}